
import { clearGeoJsonResults } from 'store/functions/geoJsonFunctions.js';
import { deleteRowHelper } from 'store/reducers/helpers/deleteRowHelper.js';
import { STATIC_MODEL_SETTINGS, STATIC_TABLE_SETTINGS } from 'store/reducers/constants/constants.js';

export const clearTableDataHelper = (state, tableName) => {
  const newState = {...state};
  let iterState = {...state};
  const idField = STATIC_TABLE_SETTINGS[tableName]['idField'] || 'UUID';
  const isResultsTable = STATIC_TABLE_SETTINGS[tableName]['isResultTable'] || false;
  if (newState.data[tableName]) {
    for (let i = newState['data'][tableName].length - 1; i >= 0 ; i--) {
      const row = newState['data'][tableName][i];
      iterState = deleteRowHelper(iterState, tableName, row[idField]);

    }
  }
  if (isResultsTable && !STATIC_TABLE_SETTINGS[tableName]['isDropsTable'] ) {
    newState['geoJson'] = clearGeoJsonResults(newState.geoJson);
  }

  if (isResultsTable) {
    newState['geoJsonFilter']['locationLayerVisible'] = true;
  }

  return newState
}

export const clearResultsHelper = (state, resetMapLayers) => {
  let newState = {...state};
  newState = clearTableDataHelper(newState, 'route_stops')
  newState = clearTableDataHelper(newState, 'dropped_trips')
  newState = clearTableDataHelper(newState, 'dropped_locations')
  newState.data.resultSummary = null;
  // Result-editing state is meaningless without results. Empty seeds (never
  // null): the scenario initializer's key-pruning recurses into objects and
  // chokes on null values.
  newState.data.resultBaseline = {};
  newState.data.resultAmendments = [];

  if (resetMapLayers) {
    newState.geoJsonFilter.locationLayerVisible = true;
    newState.geoJsonFilter.dropLayerVisible = false;
    newState.geoJsonFilter.resultsLayerVisible = false;
  }

  return newState;
}

export const validateTimeUnitViewability = (state) => {
  /**
   * Adjusts the viewability of columns after a time unit change (i.e. clock => integer)
   */
  const toggleTimeWindows = STATIC_MODEL_SETTINGS[state.activeModelType].toggleTimeWindows
  Object.keys(toggleTimeWindows).forEach((tableName) => {
    if (!toggleTimeWindows[tableName]){return;}
    else if (state.generalSettings.time[tableName] && !state.generalSettings.time[tableName].useTimeWindows) {
      //if the time windows are not being used, then we need to make sure that the time columns are not viewable
      for (const timeWindow of Object.keys(STATIC_TABLE_SETTINGS[tableName].timeWindows)) {
        const timeTypes = STATIC_TABLE_SETTINGS[tableName].timeWindows[timeWindow];
        if (timeTypes && timeTypes.constructor === Object) {
          for (const [, colName] of Object.entries(timeTypes)) {
            state.tableSettings[tableName].isViewable[colName] = false;
          }
        }
      }
    }
    else {
      const timeSettings = STATIC_TABLE_SETTINGS[tableName]['timeWindows'];
      if (state.generalSettings.time.timeUnit && state.generalSettings.time.timeUnit === 'clock') {
        if (timeSettings.pickupStart) {
          state.tableSettings[tableName].isViewable[timeSettings.pickupStart.columnNameInt] = false;
          if (state['generalSettings']['time'][tableName]['usePickupStart']) {
            state.tableSettings[tableName].isViewable[timeSettings.pickupStart.columnNameTime] = true;
          }
        }
        if (timeSettings.pickupEnd) {
          state.tableSettings[tableName].isViewable[timeSettings.pickupEnd.columnNameInt] = false;
          if (state['generalSettings']['time'][tableName]['usePickupEnd']) {
            state.tableSettings[tableName].isViewable[timeSettings.pickupEnd.columnNameTime] = true;
          }
        }
        if (timeSettings.pickupExact) {
          state.tableSettings[tableName].isViewable[timeSettings.pickupExact.columnNameInt] = false;
          if (state['generalSettings']['time'][tableName]['usePickupExact']) {
            state.tableSettings[tableName].isViewable[timeSettings.pickupExact.columnNameTime] = true;
          }
        }
        if (timeSettings.dropoffStart) {
          state.tableSettings[tableName].isViewable[timeSettings.dropoffStart.columnNameInt] = false;
          if (state['generalSettings']['time'][tableName]['useDropoffStart']) {
            state.tableSettings[tableName].isViewable[timeSettings.dropoffStart.columnNameTime] = true;
          }
        }
        if (timeSettings.dropoffEnd) {
          state.tableSettings[tableName].isViewable[timeSettings.dropoffEnd.columnNameInt] = false;
          if (state['generalSettings']['time'][tableName]['useDropoffEnd']) {
            state.tableSettings[tableName].isViewable[timeSettings.dropoffEnd.columnNameTime] = true;
          }
        }
        if (timeSettings.dropoffExact) {
          state.tableSettings[tableName].isViewable[timeSettings.dropoffExact.columnNameInt] = false;
          if (state['generalSettings']['time'][tableName]['useDropoffExact']) {
            state.tableSettings[tableName].isViewable[timeSettings.dropoffExact.columnNameTime] = true;
          }
        }
        if (timeSettings.resultsArrival) {
          state.tableSettings[tableName].isViewable[timeSettings.resultsArrival.columnNameInt] = false;
          state.tableSettings[tableName].isViewable[timeSettings.resultsArrival.columnNameTime] = true;
          if (state.generalSettings.time.timePeriodSpansDays) {
            state.tableSettings[tableName].isViewable[timeSettings.resultsArrival.columnNameDay] = true;
          } else {
            state.tableSettings[tableName].isViewable[timeSettings.resultsArrival.columnNameDay] = false;
          }
        }
        if (timeSettings.resultsDeparture) {
          state.tableSettings[tableName].isViewable[timeSettings.resultsDeparture.columnNameInt] = false;
          state.tableSettings[tableName].isViewable[timeSettings.resultsDeparture.columnNameTime] = true;
          if (state.generalSettings.time.timePeriodSpansDays) {
            state.tableSettings[tableName].isViewable[timeSettings.resultsDeparture.columnNameDay] = true;
          } else {
            state.tableSettings[tableName].isViewable[timeSettings.resultsDeparture.columnNameDay] = false;
          }
        }
      } 

      if (state.generalSettings.time.timeUnit && state.generalSettings.time.timeUnit === 'integer') {
        if (timeSettings.pickupStart) {
          state.tableSettings[tableName].isViewable[timeSettings.pickupStart.columnNameTime] = false;
          if (state['generalSettings']['time'][tableName]['usePickupStart']) {
            state.tableSettings[tableName].isViewable[timeSettings.pickupStart.columnNameInt] = true;
          }
        }
        if (timeSettings.pickupEnd) {
          state.tableSettings[tableName].isViewable[timeSettings.pickupEnd.columnNameTime] = false;
          if (state['generalSettings']['time'][tableName]['usePickupEnd']) {
            state.tableSettings[tableName].isViewable[timeSettings.pickupEnd.columnNameInt] = true;
          }
        }
        if (timeSettings.pickupExact) {
          state.tableSettings[tableName].isViewable[timeSettings.pickupExact.columnNameTime] = false;
          if (state['generalSettings']['time'][tableName]['usePickupExact']) {
            state.tableSettings[tableName].isViewable[timeSettings.pickupExact.columnNameInt] = true;
          }
        }
        if (timeSettings.dropoffStart) {
          state.tableSettings[tableName].isViewable[timeSettings.dropoffStart.columnNameTime] = false;
          if (state['generalSettings']['time'][tableName]['useDropoffStart']) {
            state.tableSettings[tableName].isViewable[timeSettings.dropoffStart.columnNameInt] = true;
          }
        }
        if (timeSettings.dropoffEnd) {
          state.tableSettings[tableName].isViewable[timeSettings.dropoffEnd.columnNameTime] = false;
          if (state['generalSettings']['time'][tableName]['useDropoffEnd']) {
            state.tableSettings[tableName].isViewable[timeSettings.dropoffEnd.columnNameInt] = true;
          }
        }
        if (timeSettings.dropoffExact) {
          state.tableSettings[tableName].isViewable[timeSettings.dropoffExact.columnNameTime] = false;
          if (state['generalSettings']['time'][tableName]['useDropoffExact']) {
            state.tableSettings[tableName].isViewable[timeSettings.dropoffExact.columnNameInt] = true;
          }
        }
        if (timeSettings.resultsArrival) {
          state.tableSettings[tableName].isViewable[timeSettings.resultsArrival.columnNameTime] = false;
          state.tableSettings[tableName].isViewable[timeSettings.resultsArrival.columnNameInt] = true;
          state.tableSettings[tableName].isViewable[timeSettings.resultsArrival.columnNameDay] = false;
        }
        if (timeSettings.resultsDeparture) {
          state.tableSettings[tableName].isViewable[timeSettings.resultsDeparture.columnNameTime] = false;
          state.tableSettings[tableName].isViewable[timeSettings.resultsDeparture.columnNameInt] = true;
          state.tableSettings[tableName].isViewable[timeSettings.resultsDeparture.columnNameDay] = false;
          }
      }

      if (state.generalSettings.time.timePeriodSpansDays && 
          state.generalSettings.time.timeUnit && state.generalSettings.time.timeUnit === 'clock') {
          if (timeSettings.pickupStart?.columnNameDay) {
            if (state['generalSettings']['time'][tableName]['usePickupStart']) {
              state.tableSettings[tableName].isViewable[timeSettings.pickupStart.columnNameDay] = true
            } else {
              state.tableSettings[tableName].isViewable[timeSettings.pickupStart.columnNameDay] = false
            }
          } 

          if (timeSettings.pickupEnd?.columnNameDay) {
            if (state['generalSettings']['time'][tableName]['usePickupEnd']) {
              state.tableSettings[tableName].isViewable[timeSettings.pickupEnd.columnNameDay] = true
            } else {
              state.tableSettings[tableName].isViewable[timeSettings.pickupEnd.columnNameDay] = false
            }
          } 

          if (timeSettings.pickupExact?.columnNameDay) {
            if (state['generalSettings']['time'][tableName]['usePickupExact']) {
              state.tableSettings[tableName].isViewable[timeSettings.pickupExact.columnNameDay] = true
            } else {
              state.tableSettings[tableName].isViewable[timeSettings.pickupExact.columnNameDay] = false
            }
          } 

          if (timeSettings.dropoffStart?.columnNameDay) {
            if (state['generalSettings']['time'][tableName]['useDropoffStart']) {
              state.tableSettings[tableName].isViewable[timeSettings.dropoffStart.columnNameDay] = true
            } else {
              state.tableSettings[tableName].isViewable[timeSettings.dropoffStart.columnNameDay] = false
            }
          } 

          if (timeSettings.dropoffEnd?.columnNameDay) {
            if (state['generalSettings']['time'][tableName]['useDropoffEnd']) {
              state.tableSettings[tableName].isViewable[timeSettings.dropoffEnd.columnNameDay] = true
            } else {
              state.tableSettings[tableName].isViewable[timeSettings.dropoffEnd.columnNameDay] = false
            }
          } 

          if (timeSettings.dropoffExact?.columnNameDay) {
            if (state['generalSettings']['time'][tableName]['useDropoffExact']) {
              state.tableSettings[tableName].isViewable[timeSettings.dropoffExact.columnNameDay] = true
            } else {
              state.tableSettings[tableName].isViewable[timeSettings.dropoffExact.columnNameDay] = false
            }
          } 
      } else { //time period does not span days - shut her down
        if (timeSettings.pickupStart?.columnNameDay) {
          state.tableSettings[tableName].isViewable[timeSettings.pickupStart.columnNameDay] = false
        }
        if (timeSettings.pickupEnd?.columnNameDay) {
          state.tableSettings[tableName].isViewable[timeSettings.pickupEnd.columnNameDay] = false
        }
        if (timeSettings.pickupExact?.columnNameDay) {
          state.tableSettings[tableName].isViewable[timeSettings.pickupExact.columnNameDay] = false
        }
        if (timeSettings.dropoffStart?.columnNameDay) {
          state.tableSettings[tableName].isViewable[timeSettings.dropoffStart.columnNameDay] = false
        }
        if (timeSettings.dropoffEnd?.columnNameDay) {
          state.tableSettings[tableName].isViewable[timeSettings.dropoffEnd.columnNameDay] = false
        }
        if (timeSettings.dropoffExact?.columnNameDay) {
          state.tableSettings[tableName].isViewable[timeSettings.dropoffExact.columnNameDay] = false
        }
      }
    
    }
  })
  return state;
}
